// src/components/ContactSection.jsx
import React from "react";
import ContactForm from "./ContactForm";

const content = {
    header: ["Start a Conversation"],
    intro: [
        "Share a few details and I will reach out to take the conversation forward."
    ],
};

export default function ContactSection() {
    return (
        <section id="contact-inline" className="py-8 px-4 scroll-mt-10">
            <div className="max-w-2xl mx-auto text-center">
                {/* Top copy */}
                <h2
                    className="text-2xl sm:text-3xl font-semibold mb-3"
                    style={{ color: "var(--text-primary)" }}
                >
                    {content.header[0]}
                </h2>
                <p className="text-base mb-8" style={{ color: "var(--text-secondary)" }}>
                    {content.intro[0]}
                </p>

                {/* Reusable Contact Form */}
                <div className="text-left">
                    <ContactForm />
                </div>
            </div>
        </section>
    );
}
